import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import Button from 'jbc-front/components/Button';
import { ScrollSpy } from 'jbc-front/components/ScrollSpy/v2';
import { AnchorTarget } from '@/components/AnchorTarget';
import { BusinessType, Office, Prefecture } from '../../query';
import { Navi } from '../Navi';
import { Title } from './Title';
import { BasicInformation } from './BasicInformation';
import { AggregationOffices } from './AggregationOffices';
import { HealthCheckupInstitution } from './HealthCheckupInstitution';
import { EmployeesCount } from './EmployeesCount';
import { SpecifiedWorkSummaries } from './SpecifiedWorkSummaries';
import { HealthCheckupSummaries } from './HealthCheckupSummaries';
import { Physician } from './Physician';
import { SubmitOn } from './SubmitOn';
import { RefreshSummary } from './RefreshSummary';
import styles from './Form.scss';

interface FormProps {
  reportId: string;
  onSubmit: () => void;
  offices?: Office[];
  prefectures?: Prefecture[];
  businessTypes?: BusinessType[];
}

export const Form: FC<FormProps> = ({ reportId, onSubmit, offices, prefectures, businessTypes }) => {
  const location = useLocation();
  const {
    formState: { isSubmitting }
  } = useFormContext();

  return (
    <ScrollSpy location={location}>
      <div className={styles.row}>
        <div>
          <Navi>
            <Button primary widthWide onClick={onSubmit} disabled={isSubmitting}>
              保存
            </Button>
          </Navi>
        </div>

        <div>
          <AnchorTarget name="title" />
          <Title />

          <AnchorTarget name="basic_information" />
          <BasicInformation
            mode="edit"
            loading={false}
            offices={offices}
            prefectures={prefectures}
            businessTypes={businessTypes}
          />

          <AnchorTarget name="office" />
          <AggregationOffices loading={false} offices={offices} />

          <AnchorTarget name="health_checkup_institution" />
          <HealthCheckupInstitution reportId={reportId} />

          <AnchorTarget name="employees_count" />
          <EmployeesCount />

          <AnchorTarget name="specified_work_summaries" />
          <SpecifiedWorkSummaries />

          <AnchorTarget name="health_checkup_summaries" />
          <HealthCheckupSummaries />

          <AnchorTarget name="physician" />
          <Physician />

          <AnchorTarget name="submit_on" />
          <SubmitOn />

          <div className="u-ta-c u-mt30">
            <RefreshSummary className="u-mr20" disabled={isSubmitting} />
            <Button primary onClick={onSubmit} disabled={isSubmitting}>
              保存
            </Button>
          </div>
        </div>
      </div>
    </ScrollSpy>
  );
};
